import type { JSX, ReactNode } from 'react';
import type { SortState } from '@/shared/types/table-filters.types';
import { ExperienceTable } from './ExperienceTable';
import { ExperienceCard } from './ExperienceCard';
import type { Experience, ExperienceStatus } from '../types/experience.types';

export interface ExperienceViewsProps {
  experiences: Experience[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (experience: Experience) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: ExperienceStatus) => void;
  renderExpandedContent: (experience: Experience) => ReactNode;
}

/** Desktop table and mobile cards render the same already filtered/sorted experiences. */
export function ExperienceViews({
  experiences,
  sort,
  onToggleSort,
  renderExpandedContent,
  ...itemHandlers
}: ExperienceViewsProps): JSX.Element {
  return (
    <>
      <div className="hidden md:block">
        <ExperienceTable
          experiences={experiences}
          sort={sort}
          onToggleSort={onToggleSort}
          renderExpandedContent={renderExpandedContent}
          {...itemHandlers}
        />
      </div>

      <div className="grid gap-4 md:hidden">
        {experiences.map((experience) => (
          <ExperienceCard
            key={experience.id}
            experience={experience}
            renderExpandedContent={renderExpandedContent}
            {...itemHandlers}
          />
        ))}
      </div>
    </>
  );
}
